import { useContext } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import LoadSvg from 'utils/LoadSvg-v3';
import AccordionContext from './AccordionContext';

function AccordionHead(props) {
  const { isOpen, isLoading, changeOpenState, iconType } = useContext(AccordionContext);

  const handleClickHeader = () => {
    changeOpenState(!isOpen);
  };

  return (
    <div className={`accordion-header ${isOpen ? 'accordion-open' : 'accordion-closed'}`} onClick={handleClickHeader}>
      {props.children}
      {isLoading && (
        <div className='accordion-loading hidden-content appear'>
          <ClipLoader color={'grey'} size={20} />
        </div>
      )}
      {!isLoading && (
        <div className='accordion-expandIcon hidden-content appear'>
          {iconType == null && <LoadSvg name='chevron' />}
          {iconType === 'type2' && <LoadSvg name='chevron' />}
        </div>
      )}
    </div>
  );
}

export default AccordionHead;
